import { ClickableMenuItem } from '@app/shared/layout/sidebar/sidebar.component';

export class SidebarNavItem {

    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);
        }
    }

    label: string = '';
    icon: string = '';
    isActiveTab?: boolean;
    routerLink?: string;
    // Highlights the item on any URL under this path. Optional with no initialiser on purpose (CODING-STANDARDS 2.9 rule 2).
    activePrefix?: string;
    url?: string;
    onClick?: (item: SidebarNavItem) => void;
    clickId?: ClickableMenuItem;
    children: SidebarNavItem[] = [];
}
